const listeners = new Set();
let frame = null;

export const bus = {
  attach(iframe) { frame = iframe; },
  post(msg) { try { frame?.contentWindow?.postMessage({ ...msg, __titanCmd: 1 }, '*'); } catch (e) { /* frame gone */ } },
  on(fn) { listeners.add(fn); return () => listeners.delete(fn); },
};

window.addEventListener('message', (e) => {
  if (!e.data || !e.data.__titan || !frame || e.source !== frame.contentWindow) return;
  listeners.forEach((fn) => fn(e.data));
});

export function capture() {
  return new Promise((resolve) => {
    const off = bus.on((m) => { if (m.type === 'capture') { off(); resolve(m.data); } });
    bus.post({ type: 'capture' });
    setTimeout(() => { off(); resolve(null); }, 1500);
  });
}

export function vibrate(p, enabled = true) {
  if (!enabled) return;
  try { navigator.vibrate && navigator.vibrate(p); } catch (e) { /* unsupported */ }
}
